









































    import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
    import { Vuetable, VuetablePagination} from 'vuetable-2';
    import { mapState } from 'vuex';
    import { StoreState, CDR, Timezone } from '../../../store';
    import momentTZ from 'moment-timezone';
    import util from '../../../lib/util';
    import 'moment-duration-format';  
    import {RotateSquare2} from 'vue-loading-spinner';
    import VueElementLoading from 'vue-element-loading';
    import * as _ from 'lodash';
     import * as moment from 'moment';  

    @Component({ 
        components: {
            Vuetable,  
            RotateSquare2,
            VueElementLoading,
            'vuetable-pagination': VuetablePagination
        },  
        computed: {
            ...mapState({
                'cdrs': (state: StoreState) => state.reports.callReports,
                'callReports': (state: StoreState) => state.reports.callReports,
                'timezone': (state: StoreState) => state.reports.filters.timezone,
                'loadingMore': (state: StoreState) => state.reports.loadingMore,
                'showLoadMoreBar': (state: StoreState) => state.reports.showLoadMoreBar,
                'total': (state: StoreState) => state.reports.total,
              
            }),
        },
       
        watch: {
           
        }
    })
    export default class Table extends Vue {
/* tslint:disable */
        cdrs!: CDR[];
        cdrsfilter!: CDR[];
        timezone!: Timezone;  
        currenPage!:any;
        total!:any;
        Loader:boolean;   
       
        downloading:boolean=false;
        oneachside:number=5;
        @Prop()
        filteredCdrs: CDR[];
	    @Prop()
		public cdr!: CDR;
        data() {
            return {
                downloadIMG:'img/icons/Download-icon1.png',
                playIMG:'img/icons/Play-arrow_fill.png',
                spinIMG:'img/icons/spinn_icon.gif',
                downloading_id:'',//boolean=false; 
                downloading_voiceid:'',
                isLoading: false,
            }
         
        }
        // get cdrCount() {
        //     return (this as any).cdrsfilter ? (this as any).cdrsfilter.length : 0;
        // }


       get timeStamp() {
        //return momentTZ(momentTZ(this.$props.cdr.timestamp, 'x').format()).format('YYYY-MM-DD hh:mma');
         if (this.VM_icon_stats){
             		 	
             //63763136408.523	
             
                return     moment((this.$props.cdr.timestamp - 62167219200) * 1000).format("YYYY-MM-DD hh:mma");

             // return   momentTZ(momentTZ(this.$props.cdr.timestamp - 62167219200).format()).tz(this.timezone.tz).format('YYYY-MM-DD hh:mm a');
            }
			 else {
               //  momentTZ(momentTZ(value, 'x').format()).tz(tz).format('YYYY-MM-DD h:mm a')
            //    /    return     momentTZ(momentTZ(this.$props.cdr.timestamp, 'x').format()).format('YYYY-MM-DD hh:mma');
                return   momentTZ(momentTZ(this.$props.cdr.timestamp, 'x').format()).tz(this.timezone.tz).format('YYYY-MM-DD hh:mm a');
             }
        }

       formatPhoneNumber(phoneNumber: any) {
		if(phoneNumber!=null){
	    var phoneNumber=	phoneNumber.split("@");
        phoneNumber=phoneNumber[0];
		return util.formatPhoneNumber(phoneNumber);
           }
		}
     
        get duration() {
			// const min = Math.floor(this.$props.cdr.duration / 60);
			// const sec = this.$props.cdr.duration % 60;
			// const secString = (sec.toString() as any).padStart(2, '0');
            // return `${min.toString()}:${secString}`;
               
             const duration = momentTZ.duration(+this.$props.cdr.duration, 'seconds');
            return momentTZ.utc(duration.asMilliseconds()).format("HH:mm:ss")
		}
        
       get infocallrep(){
            for(var i=0; i<(this as any).callReports.length; i++ ){  
                var timestamp = momentTZ(momentTZ((this as any).callReports[i].timestamp, 'x').format()).tz(this.timezone.tz).format('Y-MM-DD h:mm a');;
                (this as any).callReports[i].timestamp=  timestamp;    
                var duration = momentTZ.duration(+(this as any).callReports[i].duration, 'seconds');
                (this as any).callReports[i].duration=  momentTZ.utc(duration.asMilliseconds()).format("mm:ss")  
            }
           return  (this as any).callReports;    
       }  
        

      
       	get VM_icon_stats(){
			var time_status=this.duration=='0:00'?false: true;
			var call_record=this.$props.cdr.call_recording==null?false:true;
			var isVm= this.$props.cdr.type==="VM"
			var status=time_status&&call_record && isVm?true:false;
            return status;// this.duration=='0:00'?false: true
        } 
        get icon_stats(){ //console.log('cdr data',this.$props.cdr);
			var time_status=this.duration=='0:00'?false: true;
			var call_record=this.$props.cdr.call_recording==null?false:true;
			var isVm= this.$props.cdr.type==="VM"
			var status=time_status&&call_record && !isVm?true:false;
            return status;// this.duration=='0:00'?false: true
		} 


        play_record(media){
           // alert(media.call_recording)
           //console.log('media in play record',media);
            var payload;
            if(media.type=="VM"){
                    payload={
                     call_recording:media.call_recording,
                      timestamp:moment((media.timestamp - 62167219200) * 1000).format("YYYY-MM-DD hh:mma") //media.timeStamp
                    }
                    this.$emit('openModal', payload);
            }
            else{
                  payload={
                         call_recording:media.call_recording,
                         timestamp:(this as any).timeStamp
                     }
                     this.$emit('openModal', payload);
            }
             //this.$emit('openModal', payload);
        }

       async playVoicemail(mediaEle) {
           //console.log('media Element',mediaEle);
		 try {
			 		let _vmattachment;
			 		 await this.getvoicemailattachment().then(r => {
						 	_vmattachment=  r;
					 });
                     //console.log('_vmattachment',_vmattachment);
                     const audiourl=(_vmattachment as any).audiourl;
                     var payload={
                         call_recording:audiourl,
                         timestamp:(this as any).timeStamp
                     }
                     //console.log('payload file',payload);
                     this.play_record(payload)
					// this.$emit('openModal', payload);
                    this.$props.voicemail.folder = 'saved';
                }
            catch {
                return;
            }
		
		}
        startTime(ts, duration)
        {
            // console.log("time stamp - "+ts);
            let d_part = duration.split(":")
            let durationinsec = (parseInt(d_part[0])*60) + parseInt( d_part[1]);
            // console.log("duration - ", duration + " in sec - "+durationinsec);
            let m = moment(ts).subtract(durationinsec, 'seconds').format('YYYY-MM-DD hh:mm a');
            // console.log("diff - "+m);
            // return ts + ""+ duration; 
            // return ts +" "+ m;
            return m;
        }
        async getvoicemailattachment()
            {
                try {
				const voicemaildate = (this as any).timeStamp.split("-");
				 let m = voicemaildate[1];	
				 let y= voicemaildate[0];
				 var my= `${y}${m}`;
                const r = await this.$store.dispatch('getvoicemailaudioattachment',{media_id: this.$props.cdr.media_id, my: my} );
                 if(r) { //console.log('getting data',r.data);
					const attachment= Object.keys(r.data._attachments)[0];
					const apiurl = r.data.APIServer;
					const dbname = r.data.dbname;
					const audiourl = `${apiurl}voicemailaudio/${dbname}/${this.$props.cdr.media_id}/${attachment}`;
					//console.log('audiourl',audiourl);
                    return {audiourl:audiourl,
						attachment:attachment
					};
                }
            }
            catch {
                return;
            }
        }

        async downloadVoicemail(data)
		{
			this.downloading=true;
            let _vmattachment;
             this.$data.downloading_voiceid=data.id;// true;
			await this.getvoicemailattachment().then(r => {
						 	_vmattachment=  r;
            });
            
             this.$data.downloading_voiceid='';// true;
			const audiourl=(_vmattachment as any).audiourl;
			const attachment=(_vmattachment as any).attachment;
			this.download_mycallrecord(audiourl,attachment);
        }
        
        download_mycallrecord(url, name) {  
                const fileurl= url;//this.$props.cdr.call_recording;
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', name); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                    this.downloading=false;
              
            }




        

         download_callrecord(data) { 
            var title= this.title(data.call_recording);
            this.$data.downloading_id=data.id;// true;
            this.downloading= true; 
			const fileurl=data.call_recording;// this.$props.cdr.call_recording;
			 this.$store.dispatch('Download_paly', fileurl).then(response => {
                this.downloading=false;
                this.$data.downloading_id='';
				const url = window.URL.createObjectURL(new Blob([response.data]));
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download',title); //or any other extension
				document.body.appendChild(link);
				link.click();
                }).catch(() => {

                    });
		}
       
        title(title) {
            const dummy = title;
            const re = /call_recording_*.mp3$/;
            let res=dummy.split("/");;
                return res[res.length-1];
           
         }

        get filteredCdrCount() {
            return (this as any).$props.filteredCdrs ? (this as any).$props.filteredCdrs.length : 0;
        }
  
    
    //     onChangePage (page:any) {
    //          page=10;
    //         //alert(page)
    //          this.$store.dispatch('getCallReports', {para:{ shouldContinue: true , Page:page}}).then(r => {
    //             // alert(JSON.stringify(r))
    //             //  alert(r.cdrs.length)
    //                 this.infocallrep(); 

    //                  this.$data.isLoading = false;
    //             }).catch(() => {
    //                 this.$data.isLoading = false;
                   
    //             });
    // //             if (page=='next')
    // //             {
    // //                 var tmpPageno= this.currenPage+1;
    // //                 page=tmpPageno;
    // //             }

    // //             if (page=='prev')
    // //             {
    // //                 page=this.currenPage - 1;
    // //             }

    // //             if (page<0)page=1;

    // //             this.currenPage=page;
    // //             const total = this.cdrs.length;
    // //              let lastpage=Math.floor(total/15)   ;
    // //              if (total%15 >0 )
    // //                  lastpage++;
    // //         if (isNaN(this.currenPage))
    // //             this.currenPage=1;
         
      

    // //      if (this.currenPage==lastpage)
    // //    {
    // //        this.$store.dispatch('getCallReports', {para:{ shouldContinue: true , Page:2}}).then(() => {
    // //                  this.$data.isLoading = false;
    // //             }).catch(() => {
    // //                 this.$data.isLoading = false;
                   
    // //             });
    // //    }
    // //    else
    // //    {
    // //          (this.$refs.vuetable as any).refresh();
    // //    }
             
    //     }
        dataManager(sortOrder) {
            // console.log("dataManager: ", sortOrder, this.cdrs);
            const total= this.cdrs.length;
             let lastpage=Math.floor(total/15)  ; ;
            if (total%15 >0 )
                lastpage++;
             if (isNaN(this.currenPage))
                this.currenPage=1;
            if(this.currenPage>lastpage )
            {
                this.currenPage=1
            }
          //  ( this.$refs.pagination as any).onEachSide=3;
            const startpos= (this.currenPage-1)*15;
            this.cdrsfilter= this.cdrs.slice(startpos,startpos+15);
            var resultdata= {
              current_page:isNaN(this.currenPage) ?1:this.currenPage,
              data: this.cdrsfilter,
              from: isNaN(this.currenPage) ?1:this.currenPage,
              last_page: lastpage,

              per_page: 15,

              to: 10,
              total: total  
            };
             (this.$refs.pagination as any).setPaginationData(resultdata);
            let data = this.cdrsfilter;
           // let data = this.$props.filteredCdrs;

            // if (data.length === 0) {
            //     data = this.$data.cdrs;
            // }
            

            // sortOrder can be empty, so we have to check for that as well
            if (sortOrder.length > 0) {
                // console.log("orderBy:", sortOrder[0].sortField, sortOrder[0].direction);
                data = _.orderBy(data, sortOrder[0].sortField, sortOrder[0].direction);
            }
            

             console.log(`Post sort:`, data);
               
            return data;
        }

        // async loadMore() {
        //     await this.$store.dispatch('getCallReports', { shouldContinue: true });
        //     (this.$refs.vuetable as any).setData(this.cdrs || []);
        // }
    }
